import AsteriskMark from "./AsteriskMark";
import Logo from "./Logo";
import Tag from "./Tag";
import styles from "./AuthLayout.module.css";

export default function AuthLayout({ title, children }) {
  return (
    <div className={styles.page}>
      <AsteriskMark rotation={0} className={styles.backdrop} />

      <header className={styles.header}>
        <Logo className={styles.logo} aria-label="PropFunding" role="img" />
      </header>

      <main className={`${styles.content} d-flex flex-column align-items-center`}>
        <h1 className={styles.title}>{title}</h1>
        <Tag className={styles.badge}>Admin portal</Tag>
        <div className={styles.panel}>{children}</div>
      </main>
    </div>
  );
}
